export const SERVER_API_URL = API_URL
export const PUBLIC_PATH = ENV_PUBLIC_PATH
